import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M13.8521 4C15.1121 4 15.4821 4.732 15.4821 5.567C15.4821 6.61 14.6471 7.576 13.2211 7.576C12.0281 7.576 11.4611 6.976 11.4951 5.985C11.4951 5.149 12.1951 4 13.8521 4Z"
      fill="currentColor"
    />
    <path
      d="M10.6231 20C9.76108 20 9.13308 19.477 9.73508 17.181L10.7221 13.108C10.8931 12.457 10.9211 12.195 10.7221 12.195C10.4651 12.195 9.34508 12.645 8.68608 13.089L8.25708 12.385C10.3511 10.636 12.7581 9.60999 13.7881 9.60999C14.6501 9.60999 14.7921 10.627 14.3631 12.195L13.2321 16.476C13.0321 17.232 13.1171 17.493 13.3191 17.493C13.5781 17.493 14.4231 17.18 15.2551 16.525L15.7421 17.179C13.7031 19.217 11.4841 20 10.6231 20Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'InfoNoBorder');

export default Icon;
